export const termsAndCondition = [
    {
        id: 1,
        title: "Eligibility",
        type: "list",
        content: [
            "You must be 18 years or older to use Shmooz.",
            "By registering, you confirm the accuracy of your information (name, email, date of birth, phone, etc.).",
            "If registering on behalf of an entity, you must have authority to bind it."
        ]
    },
    {
        id: 2,
        title: "Registration & Accounts",
        type: "text",
        content:
            "Users register by verifying email via OTP and providing basic details. You are responsible for confidentiality of your credentials. KYC (PAN, GST, address, bank details) is required before listing public events. Inaccurate details may lead to suspension or termination."
    },
    {
        id: 3,
        title: "Scope of Services",
        type: "text",
        content: [
            "As an Attendee: Discover and purchase tickets, accept private invites, access digital/printable tickets.",
            "As an Event Creator: Create public or private events, sell tickets, manage check-ins, appoint staff."
        ]
    },
    {
        id: 4,
        title: "Platform Role & Liability",
        type: "text",
        content:
            "Shmooz is a facilitator between creators and attendees. We are not responsible for event content, quality, or delivery, except events directly hosted by us. Events violating policies may be taken down and refunded."
    },
    {
        id: 5,
        title: "Tickets",
        type: "list",
        content: [
            "All tickets are QR-based but may be printed.",
            "Tickets are personal, non-cancellable, non-transferable, and non-refundable except for cancellations.",
            "Each attendee receives a unique ticket.",
            "Unauthorized resale or duplication is prohibited."
        ]
    },
    {
        id: 6,
        title: "Payments & Fees",
        type: "text",
        content:
            "Payments via secure gateways; Shmooz does not store details. Booking fees are paid by attendees. Platform fees are deducted from event creator payouts. Fees may vary by price. Shmooz absorbs payment gateway fees. Payouts are post-event, net of fees, taxes, and deductions."
    },
    {
        id: 7,
        title: "Content & Code of Conduct",
        type: "text",
        content:
            "No unlawful, harmful, hateful, or infringing content. Violations may lead to removal or suspension. Event creators retain ownership of content but grant Shmooz license for promotion."
    },
    {
        id: 8,
        title: "Event Takedown",
        type: "text",
        content:
            "Reported listings will be verified. Creators may respond. If unresolved, Shmooz may takedown events and refund tickets. Repeated offenses may lead to termination."
    },
    {
        id: 9,
        title: "Termination & Suspension",
        type: "text",
        content:
            "Violators will be notified; accounts may be suspended. Unresolved or repeated violations may result in permanent bans."
    },
    {
        id: 10,
        title: "Intellectual Property",
        type: "text",
        content:
            "Platform content, code, trademarks belong to Shmooz. Users may not copy or exploit IP without consent. Event content remains creators’ property, with promotional use rights granted to Shmooz."
    },
    {
        id: 11,
        title: "Dispute Resolution",
        type: "text",
        content:
            "Disputes follow: negotiation → mediation under The Mediation Act, 2023 → binding arbitration (Arbitration & Conciliation Act, 1996). Venue: Surat, India. Language: English/Hindi/Gujarati."
    },
    {
        id: 12,
        title: "Modifications",
        type: "text",
        content:
            "Shmooz may update services, fees, or Terms anytime. Continued use constitutes acceptance."
    },
    {
        id: 13,
        title: "Limitation of Liability",
        type: "text",
        content:
            "Platform is provided “as is.” Shmooz is not liable for third-party events. No guarantees of uninterrupted access. Liability is limited to the maximum extent permitted by law."
    },
    {
        id: 14,
        title: "Governing Law & Jurisdiction",
        type: "text",
        content:
            "These Terms are governed by Indian law. Courts of Surat, Gujarat have exclusive jurisdiction."
    },
    {
        id: 15,
        title: "Contact us for Grievance's",
        type: "contact",
        contact: {
            name: "Shmooz socials LLP",
            address:
                "401/501 Riviera Towers, Behind Goverdhan Haveli, Opp. Rahul Raj Mall, Piplod, Surat – 395007, India",
            email: "info@shmooz.in",
            phone: "+91 98985 82640"
        }
    }
];


export const refundPolicy = [
    {
        id: 1,
        title: 'Ticket Purchases',
        type: 'list',
        content: [
            "Tickets are issued in the name of the individual(s) buying the ticket(s).",
            "Tickets are non-cancellable, non-refundable, and non-transferable, except in cases of event cancellation as described in this Policy."
        ]
    },
    {
        id: 2,
        title: 'Event Cancellation',
        type: 'subsections',
        subsections: [
            {
                id: '2a',
                title: 'a) Organizer-Initiated Cancellation',
                type: 'text',
                content: 'Event creators may cancel their event at any time before the event start time. Upon cancellation, Shmooz will automatically initiate refunds for all tickets purchased through the platform.'
            },
            {
                id: '2b',
                title: 'b) Shmooz-Initiated Cancellation',
                type: 'text',
                content: 'Shmooz may cancel events under the following circumstances:',
                nestedSections: [
                    {
                        id: '2b1',
                        title: '1. Missing Location Details',
                        type: 'text',
                        content: 'To protect attendees, events without confirmed location details will follow this process:',
                        steps: [
                            '<strong>First Reminder (less than 48 hours before start):</strong> Reminder sent to Organizer to add location details.',
                            '<strong>Second Reminder & Warning (less than 36 hours):</strong> Reminder + warning about auto-unpublishing if not provided 24 hours before start.',
                            '<strong>Auto Unpublish (less than 24 hrs):</strong> Event unpublished until details added; Organizer notified.',
                            '<strong>Final Auto Cancellation (1 hour before start):</strong> If no location details provided, the event is cancelled by Shmooz and refunds are initiated.'
                        ]
                    },
                    {
                        id: '2b2',
                        title: '2. Breach of Platform Policies',
                        type: 'text',
                        content: 'Events may also be cancelled if they violate Shmooz\'s Terms & Conditions, Privacy Policy, or Take Down Policy. Such cancellations are at Shmooz\'s sole discretion. Refunds will be processed for all valid ticket purchases made through the platform.'
                    }
                ]
            }
        ]
    },
    {
        id: 3,
        title: 'Refund Timelines',
        type: 'text',
        content: "Shmooz aims to process refunds within <strong>3–5 business days</strong> of cancellation. However, it may take up to <strong>10 working days or longer</strong> for your bank, card issuer, or payment provider to credit the amount. Delays may occur due to payment gateway processing, bank holidays, or technical issues beyond Shmooz's control."
    },
    {
        id: 4,
        title: 'Deductions & Fees',
        type: 'text',
        content: "Refunds, where applicable, will exclude payment gateway charges and applicable taxes deducted by the payment processor at purchase time. These charges are non-refundable."
    },
    {
        id: 5,
        title: "Individual Cancellations",
        type: 'text',
        content: "Shmooz does not process cancellations or refunds for individual booking requests once tickets are purchased. Such requests must be directed to the event organizer directly. Shmooz is not liable for refunds in these cases."
    },
    {
        id: 6,
        title: 'Eligibility for Refunds',
        type: 'text',
        content: 'Refunds apply only to tickets purchased directly through Shmooz. Tickets purchased outside the platform are not eligible. Any refund decision made jointly by the organizer and Shmooz management is final and binding.'
    },
    {
        id: 7,
        title: 'Event Commencement',
        type: 'text',
        content: 'Once an event has commenced or concluded, refunds will no longer be processed under any circumstances.'
    },
    {
        id: 8,
        title: 'Postponement or Rescheduling',
        type: 'text',
        content: 'Events cannot be postponed or rescheduled on Shmooz. If an organizer wishes to change date/time, they must cancel the existing event—cancellation will trigger refunds for tickets purchased via Shmooz. The organizer may then create a new event with updated details.'
    },
    {
        id: 9,
        title: 'Contact & Support',
        type: 'text',
        content: 'For queries regarding refunds or cancellations, please contact Shmooz Support via Contact Us or email: <a href="mailto:info@shmooz.in" style="text-decoration: underline; color: var(--tertiary-color);">info@shmooz.in</a>'
    },
    {
        id: 10,
        title: 'Policy Rights',
        type: 'text',
        content: "Shmooz reserves the right to amend or update this Policy at any time without prior notice. Users are encouraged to review this page periodically for the latest version."
    }
]